import AbstractView from "abstracts/AbstractView";

export default class ProjectCardThumbnail extends AbstractView {
	constructor($wrapper) {
		super();
		this.$wrapper = $wrapper;
		this.init();
	}

	initDOM() {
		this.$video = this.$wrapper.find('.project_card-thumbnail video');
	}

	bindEvents() {
		this.tw.st = ScrollTrigger.create({
			trigger: this.$wrapper,
			start: "top center",
			end: "bottom center",
			onToggle: self => {
				if (self.isActive) {
					this.$video[0].play();
				} else {
					this.$video[0].pause();
				}
			}
		});
	}
}
